import React from "react";
import "./getintouch.scss";
import formimg from "../../../assets/images/formimage.png";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

const schema = yup.object({
  firstname: yup.string().required("firstname is required"),
  email: yup
    .string()
    .email()
    .required("email is required")
    .matches(
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
      "Invalid email address format"
    ),
  phonemumber: yup.string().required("phone is required"),
  company: yup.string().required("company is required"),
  help: yup.string().required("help is required"),
});

const Getintouch = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    console.log(data);
    reset();
  };

  return (
    <div className="gettouch">
      <div className="gettop">
        <h2>Get In Touch</h2>
        <p>
          Aenean pellentesque mollis ante sed ornare. Vivamus in blandit ipsum.
          Etiam a dapibus arcu. Integer at fermentum mauris. Proin vulputate dui
          ac consequat varius.
        </p>
      </div>
      <div className="getform">
        <div className="formleft">
          <h3>Send a message</h3>
          <form onSubmit={handleSubmit(onSubmit)}>
            <p>First Name</p>
            <input
              type="text"
              placeholder="First Name"
              {...register("firstname")}
            />
            <span>{errors.firstname?.message}</span>
            <p>Email</p>
            <input type="email" placeholder="Email" {...register("email")} />
            <span>{errors.email?.message}</span>
            <p>Phone</p>
            <input
              type="number"
              placeholder="Phone "
              {...register("phonemumber")}
            />
            <span>{errors.phonemumber?.message}</span>
            <p>Group or Company</p>
            <input
              type="text"
              placeholder="Group or Company"
              {...register("company")}
            />
            <span>{errors.company?.message}</span>
            <p>How can we help?</p>
            <input
              type="text"
              placeholder="How can we help? "
              {...register("help")}
            />
            {/* <span>{errors.help?.message}</span> */}
            <div className="subbtn">
              <button>submit</button>
            </div>
          </form>
        </div>
        <div className="formrihgt">
          <img src={formimg} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Getintouch;
